<template>
    <Paper class="permissionMain">
        <div class="permissionMaintain">
            <el-row>
                <el-col :span="19">
                    <el-row>
                        <el-col class="permissionMaintain-list">
                            <el-input v-model="inquireData['userCode']" :placeholder="$translate('lang.E3202103220012', { defaultText: '用户名' })"></el-input>
                        </el-col>
                        <el-col class="permissionMaintain-list">
                            <el-date-picker
                                class="changSecltPosition"
                                v-model="inquireData['establishTime']"
                                type="datetimerange"
                                align="left"
                                value-format='yyyy-MM-dd HH:mm:ss'
                                :default-time="['00:00:00', '23:59:59']"
                                unlink-panels
                                range-separator="-"
                                :start-placeholder="$translate('lang.E3202101270023', { defaultText: '开始日期' })"
                                :end-placeholder="$translate('lang.E3202101270024', { defaultText: '结束日期' })"
                                size="mini"
                                :picker-options="pickerOptions"
                            ></el-date-picker>
                        </el-col>
                        <div>
                            <el-button type="primary" :loading="loading" size="mini" @click="searchChange" icon='el-icon-search'>
                                {{$translate('lang.E3202101260004', { defaultText: '查 询' })}}
                            </el-button>
                            <el-button @click="restSearchChange" size="mini" class="sn-search-reset-button">
                                {{$translate('lang.E3202101260009', { defaultText: '重 置' })}}
                            </el-button>
                        </div>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <div>
            <permission-table
                ref="permissionTable"
                :pageTotal="permissionMaintainTotal"
                :tableData="permissionMaintainTableData"
                @pageChange="permissionMaintainPage"
                @sizeChange="permissionMaintainSize"
                :config="permissionMaintainConfig">
                <div slot="page-module-btn">
                    <el-button type="primary" size="mini" @click="searchExport" icon="el-icon-upload2">
                        {{$translate('lang.E3202103220006', { defaultText: '导出' })}}
                    </el-button>
                </div>
            </permission-table>
        </div>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import permissionTable from '../../../components/IdentityComponent/Main';
import permissionMaintainConfig from './config.js';
import formatTime from '@/utils/common.js';
import { getpermissionLog, exportType } from '../../../api/logManagement';
export default {
    name: 'permissionMaintain',
    components: { Paper, permissionTable },
    data() {
        return {
            permissionMaintainConfig: permissionMaintainConfig,
            inquireData: {
                userCode: ''
            },
            loading: false,
            pickerOptions: {
                shortcuts: [
                    {
                        text: this.$translate('lang.E3202101270017', { defaultText: '最近一周' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(6), formatTime.initEndDate()]);
                        }
                    },
                    {
                        text: this.$translate('lang.E3202101270019', { defaultText: '最近一个月' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(30), formatTime.initEndDate()]);
                        }
                    },
                    {
                        text: this.$translate('lang.E3202101270021', { defaultText: '最近三个月' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(90), formatTime.initEndDate()]);
                        }
                    }
                ]
            },
            permissionMaintainTableData: [],
            permissionMaintainTotal: 0,
            page: {
                pageSize: 10,
                pageNo: 1
            }
        };
    },
    methods: {
        restSearchChange() {
            this.inquireData['userCode'] = '';
            this.getTime();
        },
        getTime() {
            const start = new Date();
            start.setHours(0);
            start.setMinutes(0);
            start.setSeconds(0);
            const end = new Date();
            end.setHours(23);
            end.setMinutes(59);
            end.setSeconds(59);
            start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 - 1));
            this.$set(this.inquireData, 'establishTime', [formatTime.formatDate(start) + ' 00:00:00', formatTime.formatDate(end) + ' 23:59:59']);
        },
        getData(params) {
            if (params.establishTime) {
                params['startTime'] = params.establishTime[0];
                params['endTime'] = params.establishTime[1];
            }
            delete params.establishTime;
            getpermissionLog(params).then(res => {
                if (+res.code === 0) {
                    this.permissionMaintainTableData = res.data.list;
                    this.permissionMaintainTotal = res.data.totalCount;
                }
                this.loading = false;
            }).catch(res => {
                this.loading = false;
            });
        },
        searchChange() {
            this.$refs.permissionTable.$refs.page.pageState = false;
            this.page.pageNo = 1;
            this.permissionMaintainConfig.page.pageSize = this.page.pageSize;
            const params = {
                ...this.page,
                ...this.inquireData
            };
            this.loading = true;
            this.getData(params);
            this.$nextTick(() => {
                this.$refs.permissionTable.$refs.page.pageState = true;
            });
        },
        searchExport() {
            const params = {
                ...this.inquireData
            };
            if (params.establishTime) {
                params['startTime'] = params.establishTime[0];
                params['endTime'] = params.establishTime[1];
            }
            delete params.establishTime;
            const url = '/api-sn/log/auth/manageExport';
            const type = 'post';
            const name = this.$translate('lang.E3202103220024', { defaultText: '权限维护日志.xls' });
            exportType(params, url, type, name);
        },
        permissionMaintainSize(pageSize) {
            this.page['pageSize'] = pageSize;
            const params = {
                ...this.page,
                ...this.inquireData
            };
            this.getData(params);
        },
        permissionMaintainPage(pageNo) {
            this.page['pageNo'] = pageNo;
            const params = {
                ...this.page,
                ...this.inquireData
            };
            this.getData(params);
        }
    },
    mounted() {
        this.getTime();
    }
};
</script>
<style lang="less">
.permissionMaintain {
    margin-bottom: 20px;
    .permissionMaintain-list {
        width: 190px;
        margin-right: 10px;
    }
    .changSecltPosition {
        width: 100%;
        .el-range__icon {
            display: none;
        }
    }
}
.permissionMain {
    .nPanel .el-table {
        height: calc(100vh - 180px) !important;
    }
    .nPanel .row-bg {
        margin-top: 20px;
    }
}
</style>